module.exports = "/images/vendor/flag-icon-css/flags/1x1/hm.svg?fc838ac0bb4f5ff27231f59d9480f842";